import * as React from "react";
import { Spinner, Link } from "components/common";
import Routes from "routing/Routes";
import useEventDefinition from "components/events/events/hooks/useEventDefinition";
import usePermissions from "hooks/usePermissions";
const EventDefinitionName = ({ eventDefinitionId, displayAsLink = true }) => {
  var _a;
  const { isPermitted } = usePermissions();
  const canViewDefinition = isPermitted(`eventdefinitions:read:${eventDefinitionId}`);
  const { data: eventDefinition, isFetching, isError } = useEventDefinition(eventDefinitionId, canViewDefinition);
  const title = (_a = eventDefinition == null ? void 0 : eventDefinition.title) != null ? _a : eventDefinitionId;
  if (isFetching) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  if (!displayAsLink || !canViewDefinition || !eventDefinition || isError) {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, title);
  }
  return /* @__PURE__ */ React.createElement(Link, { to: Routes.ALERTS.DEFINITIONS.show(eventDefinition.id), target: "_blank" }, title);
};
export default EventDefinitionName;
